import React, { useState } from "react";
import Footer from '../component/Footer';

export default function How() {
  return (
    <div className="flex-1">
      <main className="min-h-screen">
        <section className="relative bg-gradient-to-b from-sky-50 to-white pb-1 pt-1">
          <nav>
            <div className="container mx-auto px-4">
              <ol className="flex py-2 text-sm flex-col lg:flex-row md:items-start gap-2">
                <li className="flex items-center">
                  <a className="text-gray-500 hover:text-sky-600 flex items-center gap-1" href="/vi">
                    <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" className="mx-2 w-4 h-4" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                      <polyline points="9 22 9 12 15 12 15 22"></polyline>
                    </svg>
                    <span className="flex-1">Trang chủ</span>
                  </a>
                </li>
                <li className="flex items-center">
                  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" className="mx-2 w-4 h-4 text-gray-400" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><polyline points="9 18 15 12 9 6"></polyline></svg>
                  <a className="text-gray-500 hover:text-sky-600 capitalize" href="/tutorial">Hướng dẫn</a>
                </li>
                <li className="flex items-center">
                  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" className="mx-2 w-4 h-4 text-gray-400" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><polyline points="9 18 15 12 9 6"></polyline></svg>
                  <span className="text-sky-600 font-medium capitalize">Cách học chi tiết</span>
                </li>
              </ol>
            </div>
          </nav>

          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900">Hướng dẫn học Tiếng Anh theo phương pháp Effortless English</h1>
            </div>
          </div>
        </section>

        <section className="py-10 bg-white">
          <div className="container mx-auto px-4">
            <h2 className="text-2xl md:text-3xl font-bold text-center mb-12">Quy trình học 4 bước</h2>

            <StepSelector />

            <div className="bg-gray-50 rounded-2xl p-8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">1. Listen &amp; Absorb</h3>
                  <p className="text-gray-600 mb-4">Nghe câu chuyện nhiều lần với tốc độ khác nhau để làm quen với ngữ điệu và cách phát âm tự nhiên.</p>
                  <div className="bg-white rounded-xl p-4 mb-4">
                    <h4 className="font-medium text-gray-900 mb-2">Ví dụ thực tế:</h4>
                    <p className="text-gray-600">Nghe một câu chuyện về chuyến du lịch với tốc độ bình thường, sau đó nghe lại với tốc độ chậm hơn.</p>
                  </div>
                  <div className="text-sm text-gray-500">Thời gian đề xuất: 15-20 phút</div>
                </div>

                <div>
                  <h4 className="font-medium text-gray-900 mb-4">Mẹo học tập:</h4>
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3"><span className="w-6 h-6 bg-sky-100 text-sky-600 rounded-full flex items-center justify-center">1</span><span className="text-gray-600">Tập trung vào việc hiểu ý chính</span></li>
                    <li className="flex items-start gap-3"><span className="w-6 h-6 bg-sky-100 text-sky-600 rounded-full flex items-center justify-center">2</span><span className="text-gray-600">Không cần hiểu từng từ một</span></li>
                    <li className="flex items-start gap-3"><span className="w-6 h-6 bg-sky-100 text-sky-600 rounded-full flex items-center justify-center">3</span><span className="text-gray-600">Chú ý đến ngữ điệu và cách nhấn âm</span></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <h2 className="text-2xl md:text-3xl font-bold text-center mb-12">7 Nguyên Tắc Cốt Lõi</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {/** cards simplified for brevity */}
              <div className="bg-gray-50 rounded-2xl p-6 hover:shadow-lg transition-shadow">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Luôn học theo cụm từ</h3>
                <p className="text-gray-600">Học từ vựng theo cụm từ hoặc câu hoàn chỉnh thay vì từng từ riêng lẻ để hiểu nghĩa trong ngữ cảnh.</p>
              </div>
              <div className="bg-gray-50 rounded-2xl p-6 hover:shadow-lg transition-shadow">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Không học ngữ pháp truyền thống</h3>
                <p className="text-gray-600">Học ngữ pháp bằng cách nghe và lặp lại qua các câu chuyện tự nhiên.</p>
              </div>
              <div className="bg-gray-50 rounded-2xl p-6 hover:shadow-lg transition-shadow">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Nghe trước, nói sau</h3>
                <p className="text-gray-600">Tập trung vào nghe nhiều trước khi cố gắng nói.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-20 bg-sky-600">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="text-4xl font-bold text-white mb-6">Bắt đầu hành trình chinh phục tiếng Anh ngay hôm nay</h2>
              <p className="text-sky-100 mb-8 text-lg">Bạn đã sẵn sàng chưa? Hãy học thử và tham gia cộng đồng học tập sôi động của chúng tôi.</p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a className="px-6 py-3 bg-white rounded-full text-sky-600 font-semibold" href="/vi">Học thử miễn phí</a>
                <a target="_blank" rel="noopener noreferrer" className="px-6 py-3 border-2 border-white rounded-full text-white font-semibold" href="https://zalo.me/g/ejpbwq677">Tham gia cộng đồng</a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

function StepSelector() {
  const [active, setActive] = useState(1);

  const steps = [
    { id: 1, title: "Listen & Absorb", short: "Nghe nhiều lần để quen ngữ điệu." , detail: `Nghe toàn bộ câu chuyện trong nhiều lần: lần đầu để hiểu ý chính, lần sau để chú ý phát âm và ngữ điệu. Nghe ở tốc độ bình thường và chậm hơn, mỗi lần nghe cố gắng nắm bắt cảm xúc người nói.` },
    { id: 2, title: "Mini-Story Practice", short: "Luyện qua các câu chuyện ngắn.", detail: `Sau khi đã nghe, luyện lại bằng cách tóm tắt câu chuyện bằng tiếng Anh, lặp lại các câu mẫu và đóng vai để ghi nhớ cấu trúc câu.` },
    { id: 3, title: "Point of View", short: "Xem nhận xét và góc nhìn.", detail: `Phân tích quan điểm, cảm xúc, và mục đích người nói; đặt câu hỏi và trả lời bằng tiếng Anh để phát triển phản xạ ngôn ngữ.` },
    { id: 4, title: "Speaking Practice", short: "Luyện nói theo phản xạ.", detail: `Lặp lại các đoạn hội thoại, nhại giọng (shadowing) và tự nói lại câu chuyện bằng lời của mình. Ghi âm và so sánh để cải thiện phát âm và ngữ điệu.` },
  ];

  return (
    <div className="mb-12">
      <div className="flex justify-between mb-6">
        {steps.map(s => (
          <button
            key={s.id}
            onClick={() => setActive(s.id)}
            className="relative flex-1 py-4 text-center"
          >
            <span className={`block text-sm font-medium mb-2 ${active===s.id? 'text-sky-600':'text-gray-500'}`}>Bước {s.id}</span>
            <span className={`block text-lg font-bold ${active===s.id? 'text-gray-900':'text-gray-700'}`}>{s.title}</span>
            <div className={`absolute bottom-0 left-0 right-0 h-1 ${active===s.id? 'bg-sky-500':'bg-transparent'}`} />
          </button>
        ))}
      </div>

      <div className="bg-gray-50 rounded-2xl p-8">
        {active === 1 && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">1. Listen &amp; Absorb</h3>
              <p className="text-gray-600 mb-4">Nghe câu chuyện nhiều lần với tốc độ khác nhau để làm quen với ngữ điệu và cách phát âm tự nhiên.</p>
              <div className="bg-white rounded-xl p-4 mb-4">
                <h4 className="font-medium text-gray-900 mb-2">Ví dụ thực tế:</h4>
                <p className="text-gray-600">Nghe một câu chuyện về chuyến du lịch với tốc độ bình thường, sau đó nghe lại với tốc độ chậm hơn.</p>
              </div>
              <div className="text-sm text-gray-500">Thời gian đề xuất: 15-20 phút</div>
            </div>
            <div>
              <h4 className="font-medium text-gray-900 mb-4">Mẹo học tập:</h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-3"><span className="flex-shrink-0 w-6 h-6 bg-sky-100 text-sky-600 rounded-full flex items-center justify-center">1</span><span className="text-gray-600">Tập trung vào việc hiểu ý chính</span></li>
                <li className="flex items-start gap-3"><span className="flex-shrink-0 w-6 h-6 bg-sky-100 text-sky-600 rounded-full flex items-center justify-center">2</span><span className="text-gray-600">Không cần hiểu từng từ một</span></li>
                <li className="flex items-start gap-3"><span className="flex-shrink-0 w-6 h-6 bg-sky-100 text-sky-600 rounded-full flex items-center justify-center">3</span><span className="text-gray-600">Chú ý đến ngữ điệu và cách nhấn âm</span></li>
              </ul>
            </div>
          </div>
        )}

        {active === 2 && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">2. Mini-Story Practice</h3>
              <p className="text-gray-600 mb-4">Luyện qua các câu chuyện ngắn: tóm tắt, lặp lại câu mẫu và đóng vai.</p>
            </div>
            <div>
              <h4 className="font-medium text-gray-900 mb-4">Mẹo:</h4>
              <ul className="space-y-3"><li className="text-gray-600">Tóm tắt bằng 1-2 câu bằng tiếng Anh.</li><li className="text-gray-600">Lặp lại câu mẫu nhiều lần.</li></ul>
            </div>
          </div>
        )}

        {active === 3 && (
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">3. Point of View</h3>
            <p className="text-gray-600">Phân tích quan điểm và đặt câu hỏi để phát triển suy nghĩ bằng tiếng Anh.</p>
          </div>
        )}

        {active === 4 && (
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">4. Speaking Practice</h3>
            <p className="text-gray-600">Luyện nói bằng cách nhại giọng, ghi âm và so sánh để cải thiện phát âm.</p>
          </div>
        )}
      </div>
    </div>
  );
}
